import * as yup from "yup"
import { ErrorMessages } from "logics/const"

export default function stringRequired() {
  return yup.string().required(ErrorMessages.Required)
}
